

import React from "react";
import { useState } from "react";

import { X, Pencil, Save } from "lucide-react"; // Import icons

const ContactDetails = () => {

    const [isEditing, setIsEditing] = useState(false);
    const [formData, setFormData] = useState({
        firstName: "Pradeep",
        middleName: "Kumar",
        lastName: "Kumar",
        displayName: "Mukesh",
        phone: "+91 000 000 0000",
        email: "mukesh@gmail.com",
        permanentAddress: "Lorem ipsum is dummy text",
        presentAddress: "Lorem ipsum is dummy text",
        postCode: "123456",
        bio: "Lorem ipsum is dummy text"
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSave = () => {
        setIsEditing(false);
    };

    return (
            
        <div className="card">
            <div className="card-header d-flex justify-content-between align-items-center">
                <h5 className="mb-0">Contact Details</h5>
                <div>
                {isEditing ? (
                    <button onClick={handleSave} className="btn btn-success btn-sm me-2">
                    <Save size={18} className="me-1" /> Save
                    </button>
                ) : null}
                <button onClick={() => setIsEditing(!isEditing)} className="border-0 bg-transparent">
                    {isEditing ? <X className="text-danger" size={20} /> : <Pencil className="text-primary" size={20} />}
                </button>
                </div>
            </div>

            <div className="card-block">
                <div className="row mb-3">
                    <div className="col-lg-4">
                        <label className="form-label">First Name</label>
                        {isEditing ? (
                            <input type="text" name="firstName" value={formData.firstName} onChange={handleChange} className="form-control input-me f-14" />
                        ) : (
                            <p className="mb-0 f-13">{formData.firstName}</p>
                        )}
                    </div>
                    <div className="col-lg-4">
                        <label className="form-label">Middle Name</label>
                        {isEditing ? (
                            <input type="text" name="middleName" value={formData.middleName} onChange={handleChange} className="form-control input-me f-14" />
                        ) : (
                            <p className="mb-0 f-13">{formData.middleName}</p>
                        )}
                    </div>
                    <div className="col-lg-4">
                        <label className="form-label">Last Name</label>
                        {isEditing ? (
                            <input type="text" name="lastName" value={formData.lastName} onChange={handleChange} className="form-control input-me f-14" />
                        ) : (
                            <p className="mb-0 f-13">{formData.lastName}</p>
                        )}
                    </div>
                </div>

                <div className="row mb-3">
                    <div className="col-lg-4">
                        <label className="form-label">Display Name</label>
                        {isEditing ? (
                            <input type="text" name="displayName" value={formData.displayName} onChange={handleChange} className="form-control input-me f-14" />
                        ) : (
                            <p className="mb-0 f-13">{formData.displayName}</p>
                        )}
                    </div>
                    <div className="col-lg-4">
                        <label className="form-label">Phone</label>
                        {isEditing ? (
                            <input type="text" name="phone" value={formData.phone} onChange={handleChange} className="form-control input-me f-14" />
                        ) : (
                            <p className="mb-0 f-13">{formData.phone}</p>
                        )}
                    </div>
                    <div className="col-lg-4">
                        <label className="form-label">Email Id</label>
                        {isEditing ? (
                            <input type="email" name="email" value={formData.email} onChange={handleChange} className="form-control input-me f-14" />
                        ) : (
                            <p className="mb-0 f-13">{formData.email}</p>
                        )}
                    </div>
                </div>

                <div className="row mb-3">
                    <div className="col-lg-4">
                        <label className="form-label">Permanent Address</label>
                        {isEditing ? (
                            <input type="text" name="permanentAddress" value={formData.permanentAddress} onChange={handleChange} className="form-control input-me f-14" />
                        ) : (
                            <p className="mb-0 f-13">{formData.permanentAddress}</p>
                        )}
                    </div>
                    <div className="col-lg-4">
                        <label className="form-label">Present Address</label>
                        {isEditing ? (
                            <input type="text" name="presentAddress" value={formData.presentAddress} onChange={handleChange} className="form-control input-me f-14" />
                        ) : (
                            <p className="mb-0 f-13">{formData.presentAddress}</p>
                        )}
                    </div>
                    <div className="col-lg-4">
                        <label className="form-label">Post Code</label>
                        {isEditing ? (
                            <input type="text" name="postCode" value={formData.postCode} onChange={handleChange} className="form-control input-me f-14" />
                        ) : (
                            <p className="mb-0 f-13">{formData.postCode}</p>
                        )}
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-12">
                        <label className="form-label">Bio</label>
                        {isEditing ? (
                            <textarea name="bio" value={formData.bio} onChange={handleChange} className="form-control input-me f-14"></textarea>
                        ) : (
                            <p className="mb-0 f-13">{formData.bio}</p>
                        )}
                    </div>
                </div>
            </div>
        </div>
        
    );
};

export default ContactDetails;